class Extranet.Common.Permissions

  canView: (view, field) ->
    view?[field]?['view']

  canEdit: (view, field) ->
    view?[field]?['edit'] ? false
